import { defineMessages } from "react-intl";

export const rippleActionMessages = defineMessages({
  readTheDocs: {
    defaultMessage: "Read the docs",
    id: "Cm2/+V",
  },
  readTheBlogPost: {
    defaultMessage: "Read the blog post",
    id: "cti4iA",
  },
  showMe: {
    defaultMessage: "Show me",
    id: "1ACBFw",
    description: "Ripple tooltip confirmation button",
  },
  seeDocs: {
    id: "jE6w+u",
    defaultMessage: "See docs",
    description: "ripple action linking to documentation",
  },
  installPulse: {
    id: "F9116r",
    defaultMessage: "Install Pulse",
    description: "ripple action to install Saleor Pulse",
  },
  openPulse: {
    id: "r0blTm",
    defaultMessage: "Open Pulse",
    description: "ripple action to open Saleor Pulse when already installed",
  },
  explorePulse: {
    id: "c5sFXi",
    defaultMessage: "Explore Pulse",
    description: "ripple action to explore Saleor Pulse on the App Store (non-cloud)",
  },
});
